import { defineStore } from "pinia";
import router from "@/router"
import { login } from "@/api/race";

export const useStore = defineStore('user', {
  state: () => ({
    isLogin: false,
    token: '',
    activeViewIndex: 0
  }),
  actions: {
    login(username, password) {
      (async () => {
        try {
          const res = await login(username, password);
          this.token = res.Authorization;
          this.isLogin = true;
          sessionStorage.setItem('token', res.Authorization);
          router.push({name: 'race'});
        } catch (e) {
          console.log(e);
        }
      })();



    },
    updateIsLogin() {

    }
  }

})
